import { render } from "./networkpoints.vue?vue&type=template&id=627e9840&scoped=true&ts=true"
import script from "./networkpoints.vue?vue&type=script&lang=ts"
export * from "./networkpoints.vue?vue&type=script&lang=ts"

import "./networkpoints.vue?vue&type=style&index=0&id=627e9840&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627e9840"]])

export default __exports__